import {connect} from 'react-redux';
import {formValueSelector} from 'redux-form';
import EntryRosterList from 'shared/EntryRosterList.jsx';
import {
  handleIsProfessionalChange,
  handleMoveDownClick,
  handleMoveUpClick,
  handleSearchEnterKeyPress,
  handleSearchChange,
  handleSearch,
  handleRosterPositionCleared
} from '../manage/actions';
import {
  handleAssignChildTeamOwnedVirtualEventClick
} from './actions';
import {setMemberAvgField} from '../shared/actionTypes';

const entryFormSelector = formValueSelector('entryForm');

const mapStateToProps = state => ({
  source: state.registration.shared.rosterPositions,
  sourceQty: state.registration.shared.rosterPositions.length,
  bowlers: state.registration.shared.bowlers,
  parentEntryId: entryFormSelector(state, 'id'),
  childVirtualEntryEvents: state.registration.shared.childVirtualEntryEvents
    .filter(x => {
      let editingCartEntry = state.registration.shared.cartEntries.find(y => y.editing);

      return editingCartEntry ? x.eventId === editingCartEntry.eventId : false;
    }),
  childTeamOwnedVirtualEntries: state.registration.shared.childTeamOwnedVirtualEntries,
  onCartRoster: true,
  rosterCheckout: window.location.href.indexOf("rostercheckout") >= 0
});

const mapDispatchToProps = dispatch => ({
  onSearchEnterKeyPress: (roster, event) => dispatch(handleSearchEnterKeyPress(roster, event)),
  onSearchChange: (roster, event) => dispatch(handleSearchChange(roster, event)),
  onSearch: data => dispatch(handleSearch(data)),
  onAvgChange: (position, value) => dispatch(setMemberAvgField(position, value)),
  onIsProfessionalChange: (position, value) => dispatch(handleIsProfessionalChange(position, value)),
  onMoveUpClick: index => dispatch(handleMoveUpClick(index)),
  onMoveDownClick: index => dispatch(handleMoveDownClick(index)),
  onRosterPositionCleared: index => dispatch(handleRosterPositionCleared(index)),
  onAssignChildTeamOwnedVirtualEventClick: (virtualEventName, parentTeamEntryId, rosterPosition, value) => dispatch(handleAssignChildTeamOwnedVirtualEventClick(virtualEventName, parentTeamEntryId, rosterPosition, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryRosterList);



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/RosterListContainer.jsx